import { toJss } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import classnames from "classnames"
import jss from "jss"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import styles from "../../common-styles/styles.less"
import { verticalAlignValues } from "../../constants/index.es6"

import Html from "./html.jsx"

class BaseRow extends C {
  static dynamicStyles = null
  static displayName = "TableRow"

  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    containsError: PropTypes.bool,
    highlightOnSelect: PropTypes.bool,
    verticalAlign: PropTypes.oneOf(verticalAlignValues),
    onMouseDown: PropTypes.func,
    onTouchStart: PropTypes.func,
    style: PropTypes.object,
    dataSortableId: PropTypes.string,
    dataSortableLimited: PropTypes.string,
    dataSortableHandlerId: PropTypes.string,
    dataSortableType: PropTypes.string,
    dataSortableParentId: PropTypes.string,
    highlighteRow: PropTypes.bool,
    rowClickable: PropTypes.bool,
  }

  static defaultProps = {
    highlightOnSelect: true,
    onClick: () => {},
  }

  constructor(props) {
    super(props)

    if (BaseRow.dynamicStyles == null) {
      const dynamicStylesConfig = toJss((props.skinObject.table || {}).row || {}, {
        tr: {
          color: v.gray500,
        },
      })

      BaseRow.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  getChildren() {
    const { children, isLastRow } = this.props

    return React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) return child
      return React.cloneElement(child, { isLastRowColumn: isLastRow })
    })
  }

  render() {
    const { classes } = BaseRow.dynamicStyles
    const { className, containsError, highlightOnSelect, onClick, rowClickable, verticalAlign } =
      this.props

    const highlighteRowClass =
      this.props.isSelected && this.props.highlighteRow ? styles.highlighteRow : {}

    const rowClass = classnames(
      styles.tr,
      classes.tr,
      styles[verticalAlign],
      className,
      styles[rowClickable ? "rowClickable" : null],
      highlighteRowClass,
      {
        [styles.highlightOnSelect]: highlightOnSelect,
        [styles.error]: containsError,
      },
    )

    return (
      <Html
        type={this.props.htmlType}
        className={rowClass}
        onClick={onClick}
        onMouseDown={this.props.onMouseDown}
        onTouchStart={this.props.onTouchStart}
        style={this.props.style}
        dataSortableId={this.props.dataSortableId}
        dataSortableLimited={this.props.dataSortableLimited}
        dataSortableHandlerId={this.props.dataSortableHandlerId}
        dataSortableType={this.props.dataSortableType}
        dataSortableParentId={this.props.dataSortableParentId}
        dataQa={this.props.dataQa}
        dataTitle={this.props.dataTitle}
        id={this.props.id}
        ariaRowIndex={this.props.ariaRowIndex}>
        {this.getChildren()}
      </Html>
    )
  }
}

export default withSkin(BaseRow)
